<template>
  <div class="account-create-container">
    <div class="header-toolbar">
      <h2>{{ isEdit ? '编辑账号' : '新增账号' }}</h2>
      <el-button type="info" @click="goBack">返回账号列表</el-button>
    </div>

    <div class="form-container" style="width: 60%; margin: 20px auto; padding: 20px; background: #fff; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
      <el-form :model="accountForm" :rules="accountRules" ref="accountFormRef" label-width="120px">
        <!-- 用户名 -->
        <el-form-item label="用户名" prop="username">
          <el-input v-model="accountForm.username" placeholder="请输入用户名" :disabled="isEdit"></el-input>
        </el-form-item>

        <!-- 密码（新增必填，编辑可选） -->
        <el-form-item 
          label="密码" 
          prop="password"
          :required="!isEdit"
        >
          <el-input v-model="accountForm.password" type="password" placeholder="新增必填，编辑可不填（不修改密码）"></el-input>
        </el-form-item>

        <!-- 真实姓名 -->
        <el-form-item label="真实姓名" prop="realName">
          <el-input v-model="accountForm.realName" placeholder="请输入真实姓名"></el-input>
        </el-form-item>

        <!-- 客户编号（客户角色必填） -->
        <el-form-item 
          label="客户编号" 
          prop="customerNo"
          :required="accountForm.role === 'customer'"
        >
          <el-input v-model="accountForm.customerNo" placeholder="客户角色必填，其他角色可选"></el-input>
        </el-form-item>

        <!-- 角色 -->
        <el-form-item label="角色" prop="role">
          <el-select v-model="accountForm.role" placeholder="请选择角色" @change="handleRoleChange">
            <el-option label="超级管理员" value="super_admin"></el-option>
            <el-option label="管理员" value="admin"></el-option>
            <el-option label="客户" value="customer"></el-option>
          </el-select>
        </el-form-item>

        <!-- 账号状态 -->
        <el-form-item label="账号状态" prop="status">
          <el-select v-model="accountForm.status" placeholder="请选择账号状态">
            <el-option label="正常" :value="0"></el-option>
            <el-option label="禁用" :value="1"></el-option>
          </el-select>
        </el-form-item>

        <!-- 提交按钮 -->
        <el-form-item>
          <el-button type="primary" @click="submitForm">提交</el-button>
          <el-button @click="resetForm" style="margin-left: 10px;">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { addAccount, updateAccount, getAccountById } from '@/api/account'
import { Message } from 'element-ui'

export default {
  name: 'AccountCreate',
  data() {
    return {
      accountForm: {
        id: '', // 编辑时必填
        username: '',
        password: '',
        realName: '',
        customerNo: '',
        role: '',
        status: 0 // 默认正常
      },
      accountRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: false, message: '请输入密码', trigger: 'blur', min: 6 }],
        realName: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
        role: [{ required: true, message: '请选择角色', trigger: 'change' }],
        status: [{ required: true, message: '请选择账号状态', trigger: 'change' }],
        customerNo: [{ required: false, message: '客户角色必填', trigger: 'blur' }]
      },
      isEdit: false
    }
  },
  created() {
    const accountId = this.$route.query.id;
    if (accountId) {
      this.isEdit = true;
      this.getAccountDetail(accountId);
    }
  },
  methods: {
    goBack() {
      this.$router.push('/account/list');
    },
    // 角色改变时校验客户编号
    handleRoleChange() {
      this.$refs.accountFormRef.validateField('customerNo');
    },
    // 编辑回显（路径参数ID）
    getAccountDetail(id) {
      getAccountById(id)
        .then(res => {
          if (res.code === 200 && res.data) {
            const user = res.data;
            this.accountForm = {
              id: user.id,
              username: user.username,
              realName: user.realName || '',
              customerNo: user.customerNo || '',
              role: user.role || '',
              status: user.status || 0,
              password: '' // 编辑不回显密码
            };
          } else {
            Message.error('获取账号详情失败');
            this.goBack();
          }
        })
        .catch(err => {
          console.error('获取账号详情异常：', err);
          Message.error('获取账号详情失败');
          this.goBack();
        });
    },
    // 提交表单（新增→POST /user/add，编辑→PUT /user/update）
    submitForm() {
      this.$refs.accountFormRef.validate((isValid) => {
        if (isValid) {
          // 构造提交参数（适配后端DTO字段）
          const submitData = {
            username: this.accountForm.username,
            password: this.accountForm.password,
            realName: this.accountForm.realName,
            customerNo: this.accountForm.customerNo,
            role: this.accountForm.role,
            status: this.accountForm.status
          };

          // 编辑时添加ID（适配后端UserUpdateDTO）
          if (this.isEdit) {
            submitData.id = this.accountForm.id;
          }

          // 区分新增/编辑接口
          const requestPromise = this.isEdit 
            ? updateAccount(submitData) 
            : addAccount(submitData);

          requestPromise
            .then(res => {
              if (res.code === 200) {
                Message.success(this.isEdit ? '账号编辑成功' : '账号新增成功');
                this.goBack();
              } else {
                Message.error(res.msg || (this.isEdit ? '账号编辑失败' : '账号新增失败'));
              }
            })
            .catch(err => {
              console.error('提交账号异常：', err);
              Message.error(this.isEdit ? '账号编辑失败' : '账号新增失败');
            });
        } else {
          Message.warning('请完善必填字段');
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.accountFormRef.resetFields();
      if (!this.isEdit) {
        this.accountForm = {
          id: '',
          username: '',
          password: '',
          realName: '',
          customerNo: '',
          role: '',
          status: 0
        };
      }
    }
  }
}
</script>

<style scoped>
.account-create-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}
.header-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
</style>